import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const name = <FormattedMessage {...messages.warehouseLocationColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.warehouseLocationColumnHeader,
  name,
  render: (data) => data.warehouseLocation || '',
};
